import { type JobProgressionFlow } from '@/features/jobs/taxes/progression/JobProgression'

/**
 * Label for the action that requests approval of the draft return.
 */
export function getRequestDraftReturnText(
  hasDraftReturn: boolean,
  isDraftReturnDownloadable?: boolean,
  currentProgressionFlow?: JobProgressionFlow,
): string {
  if (
    currentProgressionFlow === 'Outsourcing' ||
    currentProgressionFlow === 'Review'
  ) {
    return 'Request Draft Approval'
  }

  if (!hasDraftReturn) {
    return 'Upload Draft Return'
  }

  return isDraftReturnDownloadable
    ? 'Request Draft Approval'
    : 'Verification in progress'
}
